import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class BMO_CONVENTIONAL_RESIDENTIAL_MORTGAGE_SCHEDULE_Mapper extends BaseFormMapper<BMO_CONVENTIONAL_RESIDENTIAL_MORTGAGE_SCHEDULE> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: BMO_CONVENTIONAL_RESIDENTIAL_MORTGAGE_SCHEDULE,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as BMO_CONVENTIONAL_RESIDENTIAL_MORTGAGE_SCHEDULE);

		return _formData;
	}

	MapValues(): Partial<BMO_CONVENTIONAL_RESIDENTIAL_MORTGAGE_SCHEDULE> {
		return {};
	}
}

const Mappings: BMO_CONVENTIONAL_RESIDENTIAL_MORTGAGE_SCHEDULE = {
	// "0":"ButtonSubmit0",
	specialTerms: 'FieldName8',
	others: 'FieldName7',
	yearlyRate: 'FieldName6',
	rate: 'FieldName5',
	primeRate: 'FieldName4',
	currentInterestDate: 'FieldName3',
	interestRate: 'FieldName2',
	mortgageProduct: 'FieldName1',
};

export interface BMO_CONVENTIONAL_RESIDENTIAL_MORTGAGE_SCHEDULE {
	mortgageProduct: string;
	interestRate: string;
	currentInterestDate: string;
	primeRate: string;
	rate: string;
	yearlyRate: string;
	others: string;
	specialTerms: string;
}
